<template>

	<div class="g-display-list-filtering__item g-display-list-filtering__per-page">
		<fieldset>
			<legend class="u-hide-visually">Number of Products to Show</legend>
			<ul class="g-form-list">
				<li class="g-form-list__item">
					<div class="g-form-label">View</div>
					<div class="g-display-list-per-page__options">
						<label class="g-display-list-per-page__option" v-for="option in perPage" :key="option.value" :title="`Show ${option.label} per page`">
							<input class="g-form-checkbox__input" type="radio" v-model="selectedPerPage" :value="option.value" />
							<span class="g-display-list-per-page__caption">{{option.label}}</span>
						</label>
					</div>
				</li>
			</ul>
		</fieldset>
	</div>

</template>

<script>

	import Search from '../../Search';

	export default {
		data() {
			return {
				perPage: [
					{
						label: 24,
						value: 24
					},
					{
						label: 48,
						value: 48
					},
					{
						label: 'All',
						value: 500
					}
				],
				selectedPerPage: 24
			}
		},
		props: {
			pagination: {
				default() {
					return {}
				}
			}
		},
		watch: {
			selectedPerPage( perPage, previous ) {

				if ( previous == null ) {
					return;
				}

				Search.client
					.perPage( perPage )
					.search();

			}
		}
	}

</script>
